import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import Flickity from 'react-flickity-component';
import './testimonials.css';

var Testimonials = function (_Component) {
	_inherits(Testimonials, _Component);

	function Testimonials() {
		_classCallCheck(this, Testimonials);

		return _possibleConstructorReturn(this, (Testimonials.__proto__ || Object.getPrototypeOf(Testimonials)).apply(this, arguments));
	}

	_createClass(Testimonials, [{
		key: 'render',
		value: function render() {
			var flickityOptions = {
				pageDots: true,
				prevNextButtons: false,
				wrapAround: true,
				draggable: true,
				imagesLoaded: true
			};
			var testimonials = this.props.testimonials;

			return React.createElement(
				Flickity,
				{
					className: 'testimonials' // default ''
					, elementType: 'div' // default 'div'
					, options: flickityOptions // takes flickity options {}
					, disableImagesLoaded: false // default false
					, reloadOnUpdate: true // default false
					, 'static': true // default false
				},
				testimonials.map(function (item) {
					return React.createElement(
						'div',
						{ className: 'testimonial' },
						React.createElement(
							'div',
							null,
							React.createElement('img', { src: item.image })
						),
						React.createElement(
							'div',
							null,
							React.createElement(
								'p',
								{ className: 'quote' },
								item.content
							),
							React.createElement(
								'h3',
								null,
								item.author
							),
							React.createElement(
								'h3',
								null,
								item.company
							),
							React.createElement(
								'p',
								null,
								item.role
							)
						)
					);
				})
			);
		}
	}]);

	return Testimonials;
}(Component);

export default Testimonials;